/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {InputLabel, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import {API} from "../../../config";
import Util from "../../../yeffect/utils";

const country = API.service('country');

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CountrySelect extends Component {
    state = {
        active:     this.props.active || 1,
        countries:  false,
        options:    false,
    };

    updateOptions = () => {
        const app = this;

        let options = [];

        if(this.props.categoryValue === 'E'){

            if(this.props.groupValue === 'S'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'F'
                || this.props.groupValue === 'L'
            ) {
                options.push(
                    {value: 'V', label: 'V: Voting'},
                    {value: 'N', label: 'N: Non Voting'},
                    {value: 'R', label: 'R: Restricted Voting'},
                    {value: 'E', label: 'E: Enhanced Voting'},
                )
            }

            if(this.props.groupValue === 'D') {
                options.push(
                    {value: 'S', label: 'S: Common/Ordinary Shares'},
                    {value: 'P', label: 'P: Preferred/Preference Shares'},
                    {value: 'C', label: 'C: Common/Ordinary Convertible Shares'},
                    {value: 'F', label: 'F: Preferred/Preference Convertible Shares'},
                    {value: 'L', label: 'L: Limited Partnership Units'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'Y') {
                options.push(
                    {value: 'A', label: 'A: Tracker Certificate'},
                    {value: 'B', label: 'B: Outperforming Certificate'},
                    {value: 'C', label: 'C: Bonus Certificate'},
                    {value: 'D', label: 'D: Outperformance Bonus Certificate'},
                    {value: 'E', label: 'E: Twin-Win-Certificate'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'M') {
                options.push(
                    {value: 'X', label: 'X: Not Applicable/Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'D'){

            if(this.props.groupValue === 'B') {
                options.push(
                    {value: 'F', label: 'F: Fixed Rate'},
                    {value: 'Z', label: 'Z: Zero Rate/Discounted'},
                    {value: 'V', label: 'V: Variable'},
                    {value: 'C', label: 'C: Cash Payment'},
                    {value: 'K', label: 'K: Payment in Kind'},
                )
            }
            if(this.props.groupValue === 'C'
                || this.props.groupValue === 'W'
                || this.props.groupValue === 'T'
                || this.props.groupValue === 'Y') {
                options.push(
                    {value: 'F', label: 'F: Fixed Rate'},
                    {value: 'Z', label: 'Z: Zero Rate/Discounted'},
                    {value: 'V', label: 'V: Variable'},
                    {value: 'K', label: 'K: Payment in Kind'},
                )
            }

            if(this.props.groupValue === 'S') {
                options.push(
                    {value: 'A', label: 'A: Capital Protection Certificate with Participation'},
                    {value: 'B', label: 'B: Capital Protection Convertible Certificate'},
                    {value: 'C', label: 'C: Barrier Capital Protection Certificate'},
                    {value: 'D', label: 'D: Capital Protection Certificate with Coupons'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'E') {
                options.push(
                    {value: 'A', label: 'A: Discount Certificate'},
                    {value: 'B', label: 'B: Barrier Discount Certificate'},
                    {value: 'C', label: 'C: Reverse Convertible'},
                    {value: 'D', label: 'D: Barrier Reverse Convertible'},
                    {value: 'E', label: 'E: Express Certificate'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'G'
                || this.props.groupValue === 'A'
                || this.props.groupValue === 'N') {
                options.push(
                    {value: 'F', label: 'F: Fixed Rate'},
                    {value: 'Z', label: 'Z: Zero Rate/Discounted'},
                    {value: 'V', label: 'V: Variable'},
                )
            }

            if(this.props.groupValue === 'D') {
                options.push(
                    {value: 'B', label: 'B: Bonds'},
                    {value: 'C', label: 'C: Convertible Bonds'},
                    {value: 'W', label: 'W: Bonds with Warrants Attached'},
                    {value: 'T', label: 'T: Medium-Term Notes'},
                    {value: 'Y', label: 'Y: Money Market Instruments'},
                    {value: 'G', label: 'G: Mortgage-Backed Securities'},
                    {value: 'A', label: 'A: Asset-Backed Securities'},
                    {value: 'N', label: 'N: Municipal Bonds'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'M') {
                options.push(
                    {value: 'B', label: 'B: Bank Loan'},
                    {value: 'C', label: 'P: Promissory Note'},
                    {value: 'W', label: 'M: Others(Miscellaneous)'},
                )
            }
        }

        if(this.props.categoryValue === 'C') {

            if (this.props.groupValue === 'I'
                || this.props.groupValue === 'B'
                || this.props.groupValue === 'E'
                || this.props.groupValue === 'S'
                || this.props.groupValue === 'F'
                || this.props.groupValue === 'P'
            )
            {
                options.push(
                    {value: 'C', label: 'C: Closed-End'},
                    {value: 'O', label: 'O: Open-End'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'H') {
                options.push(
                    {value:'D', label:'D: Directional'},
                    {value:'R', label:'R: Relative Value'},
                    {value:'S', label:'S: Security Selection'},
                    {value:'E', label:'E: Event-Driven'},
                    {value:'A', label:'A: Arbitrage'},
                    {value:'N', label:'N: Multi-Strategy'},
                    {value:'L', label:'L: Asset Based Lending'},
                    {value:'M', label:'M: Others'},
                )
            }

            if (this.props.groupValue === 'M') {
                options.push(
                    {value:'X', label:'X: Not Applicable / Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'R') {

            if (this.props.groupValue === 'S'
                || this.props.groupValue === 'P'
            )
            {
                options.push(
                    {value:'S', label:'S: Common/Ordinary Shares'},
                    {value:'P', label:'P: Preferred/Preference Shares'},
                    {value:'C', label:'C: Common/Ordinary Convertible Shares'},
                    {value:'F', label:'F: Preferred/Preference Convertible Shares'},
                    {value:'B', label:'B: Bonds'},
                    {value:'I', label:'I: Combined Instruments'},
                    {value:'M', label:'M: Others (Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'W'
                || this.props.groupValue === 'F') {
                options.push(
                    {value:'B', label:'B: Baskets'},
                    {value:'S', label:'S: Equities'},
                    {value:'D', label:'D: Debt Instruments/Interest Rates'},
                    {value:'T', label:'T: Commodities'},
                    {value:'C', label:'C: Currencies'},
                    {value:'I', label:'I: Indices'},
                    {value:'M', label:'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'D') {
                options.push(
                    {value:'A',label:'A: Allotment (Bonus) Rights'},
                    {value:'S',label:'S: Subscription Rights'},
                    {value:'P',label:'P: Purchase Rights'},
                    {value:'W',label:'W: Warrants'},
                    {value:'M',label:'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'M'
                || this.props.groupValue === 'A'
            ) {
                options.push(
                    {value:'X', label:'X: Not Applicable / Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'O') {

            if (this.props.groupValue === 'C'
                || this.props.groupValue === 'P'
            )
            {
                options.push(
                    {value:'E',label:'E: European'},
                    {value:'A',label:'A: American'},
                    {value:'B',label:'B: Bermudan'},
                )
            }

            if (this.props.groupValue === 'M') {
                options.push(
                    {value:'X', label:'X: Not Applicable / Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'F') {

            if (this.props.groupValue === 'F')
            {
                options.push(
                    {value:'B',label:'B: Baskets'},
                    {value:'S',label:'S: Stock-Equities'},
                    {value:'D',label:'D: Debt Instruments'},
                    {value:'C',label:'C: Currencies'},
                    {value:'I',label:'I: Indices'},
                    {value:'O',label:'O: Options'},
                    {value:'F',label:'F: Futures'},
                    {value:'W',label:'W: Swaps'},
                    {value:'N',label:'N: Interest Rates'},
                    {value:'V',label:'V: Stock Dividend'},
                    {value:'M',label:'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'C') {
                options.push(
                    {value:'E',label:'E: Extraction Resources'},
                    {value:'A',label:'A: Agriculture'},
                    {value:'I',label:'I: Industrial Products'},
                    {value:'S',label:'S: Services'},
                    {value:'N',label:'N: Environmental'},
                    {value:'P',label:'P: Polypropylene Products'},
                    {value:'H',label:'H: Generated Resources'},
                    {value:'M',label:'M: Others'},
                )
            }
        }

        if(this.props.categoryValue === 'T') {

            if (this.props.groupValue === 'C') {
                options.push(
                    {value: 'N', label: 'N: National Currency'},
                    {value: 'L', label: 'L: Legacy Currency'},
                    {value: 'C', label: 'C: Bullion Coins'},
                    {value: 'M', label: 'M: Others'},
                )
            }

            if (this.props.groupValue === 'T') {
                options.push(
                    {value: 'E', label: 'E: Extraction Resources'},
                    {value: 'A', label: 'A: Agriculture'},
                    {value: 'I', label: 'I: Industrial Products'},
                    {value: 'S', label: 'S: Services'},
                    {value: 'N', label: 'N: Environmental'},
                    {value: 'P', label: 'P: Polypropylene Products'},
                    {value: 'H', label: 'H: Generated Resources'},
                    {value: 'M', label: 'M: Others'},
                )
            }

            if (this.props.groupValue === 'R') {
                options.push(
                    {value: 'N', label: 'N: Nominal'},
                    {value: 'V', label: 'V: Variable'},
                    {value: 'F', label: 'F: Fixed'},
                    {value: 'R', label: 'R: Real'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'I') {
                options.push(
                    {value: 'E', label: 'E: Equities'},
                    {value: 'D', label: 'D: Debt'},
                    {value: 'F', label: 'F: Collective Investment Vehicles'},
                    {value: 'R', label: 'R: Real Estate'},
                    {value: 'T', label: 'T: Commodities'},
                    {value: 'C', label: 'C: Currencies'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'B') {
                options.push(
                    {value: 'E', label: 'E: Equities'},
                    {value: 'D', label: 'D: Debt'},
                    {value: 'F', label: 'F: Collective Investment Vehicles'},
                    {value: 'I', label: 'I: Indices'},
                    {value: 'T', label: 'T: Commodities'},
                    {value: 'C', label: 'C: Currencies'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'D') {
                options.push(
                    {value: 'S', label: 'S: Common Ordinary Shares'},
                    {value: 'P', label: 'P: Preferred/Preference Shares'},
                    {value: 'C', label: 'C: Common Ordinary Convertible Shares'},
                    {value: 'F', label: 'F: Preferred/Preference Convertible Shares'},
                    {value: 'L', label: 'L: Limited Partnership Units'},
                    {value: 'K', label: 'K: Collective Investment Vehicles'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'M') {
                options.push(
                    {value: 'X', label: 'X: Not Applicable / Undefined'},
                )
            }
        }
        if(this.props.categoryValue === 'M') {

            if (this.props.groupValue === 'C')
            {
                options.push(
                    {value:'S',label:'S: Combination of Shares'},
                    {value:'B',label:'B: Combination of Bonds'},
                    {value:'H',label:'H: Share and Bond'},
                    {value:'A',label:'A: Share and Warrant'},
                    {value:'W',label:'W: Warrant and Warrant'},
                    {value:'U',label:'U: Fund Unit and Other Components'},
                    {value:'M',label:'M: Others(Miscellaneous)'},
                )
            }

            if (this.props.groupValue === 'M') {
                options.push(
                    {value:'R',label:'R: Real Estate Deeds'},
                    {value:'I',label:'I: Insurance Policies'},
                    {value:'E',label:'E: Escrow Receipts'},
                    {value:'T',label:'T: Trade Finance Instruments'},
                    {value:'N',label:'N: Carbon Credit'},
                    {value:'P',label:'P: Precious Metal Receipts'},
                    {value:'S',label:'S: Other OTC Derivative Products'},
                    {value:'M',label:'M: Others(Miscellaneous)'},
                )
            }
        }

        app.setState({
            options: options
        })
    }

    componentDidMount() {
        this.updateOptions();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(this.props.categoryValue !== prevProps.categoryValue || this.props.groupValue !== prevProps.groupValue){
            this.updateOptions();
        }
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields, categoryValue} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel shrink={(!Util.isEmpty(value) || value === false)} id={fieldName + '_label'}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {(this.state.options !== false) &&
                            this.state.options.map(o => {
                                return (
                                    <MenuItem value={o.value}>{o.label}</MenuItem>
                                )

                            })
                            }
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CountrySelect);



// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CFILevel1Select.js